module.exports = __webpack_public_path__ + "img/sold-sign.svg";